<template>
  <video ref="videoPlayer" class="video-js video-js-customer"></video>
</template>
<script>
import Vue from 'vue'
import 'video.js/dist/video-js.css'
import Video from 'video.js'
import video_zhCN from 'video.js/dist/lang/zh-CN.json'
Video.addLanguage('zh-CN', video_zhCN);
Vue.prototype.$video = Video;
export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = this.$video(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log("onPlayerReady", this);
      }
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style scoped lang="scss">
.video-js.video-js-customer {
  /deep/.vjs-big-play-button {
    height: 1.63332em;
    width: 1.63332em;
    // top: calc(50% - 0.81666em);
    left: calc(50% + .67em);
    border-radius: 50%;
  }
}
</style>
